import { createFileRoute } from '@tanstack/react-router'
import Stats from '../components/Stats'

export const Route = createFileRoute('/stats')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div>
      <Stats />
    </div>
  )
}
